import { apiClient } from "helpers/api_helper"

export const GetAllWalkInSourceData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/customer/GetAllWalkInSourceGrid`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getAllWalkInSourceForSelect = async () => {
    try {
        const response = await apiClient.get(`/api/v1/customer/GetWalkInSourceSelectList`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};